export default {
    //   defaultBaseUrl: 'https://back.mhaoxiong.com',
    //   defaultBaseUrl: 'http://192.168.3.16:10001',
    //   h5Host: 'http://192.168.3.135',
    //   shdHost: 'http://localhost:8301',
    //   PChost: 'http://test.pc.ikbh.top'

    defaultBaseUrl: '/prod-api',
    h5Host: '',
    shdHost: '/erp',
    PChost: ''

    // defaultBaseUrl:'/prod-api',
    // h5Host:'https://h5.yududs.com',
    // shdHost:'/erp',
    // PChost:'https://yududs.com'
}
